import { Directive, HostListener, Input } from '@angular/core'
import { Amplitude } from '../../../../injectable'

@Directive({
    selector: '[appTrackInput]'
})
export class TrackInputDirective {
    @Input() metric: string;
    @Input() debounceMs: number = 100; // Avoid double or duplicate changes

    constructor(private _amplitude: Amplitude) {
    }

    // Trigger the event when the user leaves the input (focusout)
    @HostListener('focusout', ['$event.target'])
    onFocusOut(target: HTMLInputElement) {
        if (this.metric && target.value.trim() !== '') {
            // Emit event only if the input is not empty
            this._amplitude.logEventWithDebounce(this.debounceMs, this.metric)
        }
    }
}
